import React from "react";
import { Box, Button } from "@mui/material";
import ActionsTable from "../../components/ActionsTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import {
  getLicenceStandardsAction,
  updateActionsLicence,
} from "../../api/licence";
import { useDispatch, useSelector } from "react-redux";
import { setLicenceStandardsActions } from "../../redux/reducers/licence";
import { useTranslation } from "react-i18next";
import { setSnackBarData } from "../../redux/reducers/common";
import { archiveAction } from "../../api/action";
import { getStaff } from "../../api/user";
import { setProjectList, setStaffList } from "../../redux/reducers/evaluation";
import { getProjectsByClub } from "../../api/club";

const ActionContents = (props: any) => {
  const { standard } = props;
  const [t] = useTranslation();
  const currentClub = useSelector((state: any) => state.clubDetails);
  const standardsActions = useSelector(
    (state: any) => state.licence.standardsActions,
  );
  const dispatch = useDispatch();
  const [fetchActions, setFetchActions] = React.useState(false);
  const [addAction, setAddAction] = React.useState(false);
  const isAdmin = useSelector((state: any) => state.common.isAdmin);
  const tableHead = [
    {
      key: "",
      displayName: "",
    },
    {
      key: "status",
      displayName: "status",
    },
    {
      key: "actionComment",
      displayName: "action",
    },
    {
      key: "description",
      displayName: "description",
    },
    {
      key: "dueDate",
      displayName: "due date",
    },
    {
      key: "owner",
      displayName: "owner",
    },
    {
      key: "",
      displayName: "",
    },
  ];

  const initialAdminAction = {
    name: "",
    description: "",
    isCreatedByJL: true,
    isArchived: false,
    isAlreadyComplete: false,
    licenceJLActionStatus: false,
    ragb: 4,
  };

  React.useEffect(() => {
    const fetchLicenceStandardsActions = async () => {
      try {
        setFetchActions(true);
        const response = await getLicenceStandardsAction({
          clubId: currentClub.id,
          standardId: standard.id,
        });
        dispatch(setLicenceStandardsActions(response));
        setFetchActions(false);
      } catch {}
    };
    fetchLicenceStandardsActions();
  }, [standard]);

  const manageCRUDMethod = async (type: string, dataToUpdate?: any) => {
    switch (type) {
      // CRUD for criteria evaluation actions
      case "create":
        var actionArr: any = [dataToUpdate, ...standardsActions];
        dispatch(setLicenceStandardsActions(actionArr));
        setAddAction(false);
        const parameters = {
          clubId: currentClub?.id,
          actions: actionArr,
          standardId: standard?.id,
        };
        updateActionsLicence(parameters).then((res: any) => {
          dispatch(setLicenceStandardsActions(res));
          const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("ACTION_CREATED_SUCCESSFULLY"),
          };
          dispatch(setSnackBarData(warningData));
        });
        break;

      case "update":
        var updateActionArr: any = standardsActions?.map((d: any) =>
          d?.id == dataToUpdate?.id ? dataToUpdate : d,
        );
        dispatch(setLicenceStandardsActions(updateActionArr));
        const updateParameters = {
          clubId: currentClub?.id,
          actions: updateActionArr,
          standardId: standard?.id,
        };
        updateActionsLicence(updateParameters).then((res: any) => {
          dispatch(setLicenceStandardsActions(res));
          const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("ACTION_UPDATED_SUCCESSFULLY"),
          };
          dispatch(setSnackBarData(warningData));
        });
        break;

      case "delete":
        var tempArrDelete = standardsActions.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate,
        );
        dispatch(setLicenceStandardsActions(tempArrDelete));
        const deleteParameters = {
          clubId: currentClub?.id,
          actions: tempArrDelete,
          standardId: standard?.id,
        };
        updateActionsLicence(deleteParameters).then((res: any) => {
          dispatch(setLicenceStandardsActions(res));
          const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("ACTION_DELETED_SUCCESSFULLY"),
          };
          dispatch(setSnackBarData(warningData));
        });
        break;

      case "issue_unissue":
        let issueUnIssueTempArr: any = standardsActions.map((obj: any) => {
          if (obj.id == dataToUpdate?.id || !("id" in dataToUpdate)) {
            return {
              ...obj,
              licenceJLActionStatus: !obj.licenceJLActionStatus,
            };
          }
          return obj;
        });
        dispatch(setLicenceStandardsActions(issueUnIssueTempArr));
        const issueUnIssueParameters = {
          clubId: currentClub.id,
          actions: issueUnIssueTempArr,
          standardId: standard.id,
        };
        updateActionsLicence(issueUnIssueParameters).then((res: any) => {
          dispatch(setLicenceStandardsActions(res));
          const warningData: any = {
            isOpen: true,
            severity: "success",
            message: t("ACTION_UPDATED_SUCCESSFULLY"),
          };
          dispatch(setSnackBarData(warningData));
        });
        break;

      case "archive":
        var tempArrArchive = standardsActions.filter(
          (actionItem: any) => actionItem.id !== dataToUpdate,
        );
        dispatch(setLicenceStandardsActions(tempArrArchive));
        break;

      //   case `unlink`:
      //     var tempArrUnlink = actions.filter(
      //       (actionItem: any) => actionItem.id !== dataToUpdate
      //     );
      //     dispatch(setSaActions(tempArrUnlink));
      //     break;
    }
  };

  const manageAddAction = () => {
    if (currentClub?.id) {
      getStaff({ clubId: currentClub?.id }).then((res: any) => {
        dispatch(setStaffList(res));
      });
      getProjectsByClub({ clubId: currentClub?.id }).then((res: any) => {
        dispatch(setProjectList(res));
      });
    }
    setAddAction(true);
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Button
          className="smallButton"
          sx={{ float: "right" }}
          disableElevation
          onClick={manageAddAction}
          variant="contained"
          size="small"
          startIcon={<FontAwesomeIcon icon={faPlus} />}
          disabled={addAction}
        >
          {"Add Action"}
        </Button>
      </Box>
      <Box sx={{ mt: 1 }}>
        <ActionsTable
          //re-work on this logic to display only the issued jl actions and club actions
          // data={criteriaActions?.filter((d:any) => d.licenceJLActionStatus || !d.isCreatedByJL) || []}
          data={
            isAdmin
              ? standardsActions
              : standardsActions?.filter(
                  (d: any) =>
                    (d?.isCreatedByJL && d?.licenceJLActionStatus) ||
                    !d?.isCreatedByJL,
                )
          }
          head={tableHead}
          isAction={false}
          addAction={addAction}
          module={"LICENCE"}
          currentStandard={standard}
          isLoading={fetchActions}
          bg={"#FAFAFA"}
          handleClick={() => setAddAction(false)}
          manageCRUD={manageCRUDMethod}
          initialNewAction={isAdmin ? initialAdminAction : null}
        />
      </Box>
    </>
  );
};

export default ActionContents;
